import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData/appDataSlice";
import "./LongerShorterMenu.css";
import "../../css/Icons.css";
import { LinkRecord, Snippet } from "winslow-core";

const LONGER_SHORTER_MENU = {
  LONGER: "longer",
  SHORTER: "shorter",
  REVERT: "revert",
};

type LongerShorterMenuProps = {
  snippet: Snippet;
  onLonger: () => void;
  onShorter: () => void;
  onRevert: () => void;
  usedOption: "longer" | "shorter" | null;
};

export default function LongerShorterMenu({
  snippet,
  onLonger,
  onShorter,
  onRevert,
  usedOption,
}: LongerShorterMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const storeUser = useSelector(selectUser);

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case LONGER_SHORTER_MENU.LONGER:
        onLonger();
        break;
      case LONGER_SHORTER_MENU.SHORTER:
        onShorter();
        break;
      case LONGER_SHORTER_MENU.REVERT:
        onRevert();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div
        className="longer-shorter-menu-image-and-name"
        onClick={handleButtonClick}>
        <div className="longer-shorter-menu-caret">
          <img
            src={`/icons/${storeUser?.theme || "light-mode"}/ai_on.svg`}
            alt=""
          />
        </div>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}>
        {!usedOption && [
          <MenuItem
            onClick={() => handleMenuSelection(LONGER_SHORTER_MENU.LONGER)}>
            Make Longer
          </MenuItem>,
          <MenuItem
            onClick={() => handleMenuSelection(LONGER_SHORTER_MENU.SHORTER)}>
            Make Shorter
          </MenuItem>,
        ]}

        {usedOption && (
          <MenuItem
            onClick={() => handleMenuSelection(LONGER_SHORTER_MENU.REVERT)}>
            Revert
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
